import { createContext } from 'react';

export interface SideNavigationContextValue {
	compact: boolean;
}

export const SideNavigationContext = createContext<SideNavigationContextValue>({
	compact: false,
});
